// Vendor imports
const { connect } = require('react-redux')
// Lib imports
const businessEvents = require('client/lib/business-events')
// Container imports
const UserProfileLayout = require('./component-dumb')
const selectors = require('client-v2/into-landing/components/into-item-card-selectors')

function mapStateToProps(state) {
  return {
    // Flags
    isAndroid: state.env.browser.has('android'),
    isIos: state.env.browser.has('ios'),
    isDesktop: state.env.browser.has('isDesktop'),
    // Values
    deeplinkUrls: state.env.deeplinkUrls,
    items: selectors.getItemCards(state),
    likeCount: state.feed.meta.total ? state.feed.meta.total.toLocaleString('en-US') : '',
    user: state.profileUser,
    userStats: state.profileUserStats
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onPaginate: function () {
      dispatch(async function (dispatch, getState) {
        const { nextUrl } = getState().feed.meta
        const pageNumber = nextUrl.split('/').pop()
        await businessEvents.trackSegment('into-user-profile-scroll', {
          pageNumber
        })
      })
    }
  }
}

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  UserProfileLayout
)

module.exports = SmartComponent
